<template>
    <div class="session__show_attendance">
        <template v-if="registerVisiblity">
            <session-show-attendance-item
                v-for="(session, index) in sessionOccurrences"
                :item="session"
                :key="index"
                :id="session.id"
                :title="`${index + 1} of ${sessionOccurrences.length}`"
                :description="$t('ebs.sessions.show.description.register')"
                :date="session.date"
                :to="{ name: 'ebs-session-register', params: { registerId: session.id } }"
            />
        </template>
        <template v-if="sessionCompletionType === 'assessment'">
            <session-show-attendance-item
                :id="'summary-report'"
                :title="$t('ebs.sessions.show.title.trainerAssessment')"
                :description="$t('ebs.sessions.show.description.assessmentReport')"
                :status="sessionDigitalRegisterSummaryStatus"
                :to="{ name: 'ebs-session-summary' }"
            />
        </template>
    </div>
</template>

<script>
import SessionShowAttendanceItem from '@/components/ebs/sessions/show/SessionShowAttendanceItem'

export default {
  components: { SessionShowAttendanceItem },
  name: 'session-show-attendance',
  computed: {
    registerVisiblity: function () {
      return (
        this.sessionCompletionEnableRegisters ||
        (
          this.sessionCompletionType === 'attendance' ||
          this.sessionCompletionType === 'automatic'
        )
      )
    },
    sessionOccurrences: function () {
      return this.$store.getters.getSessionOccurrenceItems
    },
    sessionDigitalRegisterSummaryStatus: function () {
      return this.$store.getters.getSessionDigitalRegisterSummaryStatus
    },
    sessionCompletionEnableRegisters: function () {
      return this.$store.getters.getSessionCompletionEnableRegisters
    },
    sessionCompletionType: function () {
      return this.$store.getters.getSessionCompletionType
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionshowattendance";
</style>
